import React, { Component, Fragment } from 'react';
import { history } from 'components/App/components/UnauthenticatedApp';
import axios from 'axios';
import { connect } from 'react-redux';
import { notify } from 'reapop';
import getNotifications from 'utilities/notifications';
import './Profile.module.scss';

/**
 * Import components
 */
import Menu from 'components/UI/Menu/Menu';
import Popup from 'components/UI/Popup/Popup';

/**
 * Import FontAwesome
 */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import logoutUser from 'actions/authentication/logout';
import updateUser from 'actions/user/update';

const mapDispatchToProps = {
    logoutUser,
    updateUser,
    notify
};

const mapStateToProps = (state, props) => {
    return {
        user: state.authentication.user,
        token: state.authentication.token
    };
};

class Profile extends Component {

    constructor() {
        super();

        this.state = {
            showMenu: false,
            name: '',
            use_timer: true,
            email: '',
            password_current: '',
            password: '',
            password_confirmation: ''
        };

        this.switchMenu = this.switchMenu.bind(this);
        this.logout = this.logout.bind(this);
        this.updateUser = this.updateUser.bind(this);

        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handleCurrentPasswordChange = this.handleCurrentPasswordChange.bind(this);
        this.handleNewPasswordChange = this.handleNewPasswordChange.bind(this);
        this.handlePasswordConfirmationChange = this.handlePasswordConfirmationChange.bind(this);
        this.handleUseTimerChange = this.handleUseTimerChange.bind(this);
        this.buyLicense                 = this.buyLicense.bind(this);

    }
    componentDidMount() {
        this.setState({
            name: this.props.user.name,
            email: this.props.user.email,
            use_timer: this.props.user.use_timer,
        });

        getNotifications().then((result) => {
            console.log(result.data);
            result.data && result.data.forEach(notification =>
                this.props.notify({
                    message: notification.data.message,
                    dismissAfter: 10000,
                    dismissible: true,
                    status: notification.data.status,
                    position: 'tc'
                })
            );
        });
    }

    handleNameChange(event) {
        this.setState({ name: event.target.value });
    }

    handleEmailChange(event) {
        this.setState({ email: event.target.value });
    }

    handleCurrentPasswordChange(event) {
        this.setState({ password_current: event.target.value });
    }

    handleNewPasswordChange(event) {
        this.setState({ password: event.target.value });
    }

    handlePasswordConfirmationChange(event) {
        this.setState({ password_confirmation: event.target.value });
    }

    handleUseTimerChange(event) {
        this.setState({ use_timer: event.target.checked });

    }

    switchMenu(e) {
        this.state.showMenu ? this.setState({ showMenu: false }) : this.setState({ showMenu: true });
    }

    buyLicense() {
        let config = {
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${this.props.token.access_token}`
            },
            baseURL: '/api'
        };
        let fetch = axios.create(config);
        fetch.post('/payment/buyLicense', {

        }).then((result) => {
            window.location.replace(result.data.url);
        }).catch((e) => console.error(e));
    }

    logout() {
        this.props.logoutUser();
    }

    updateUser() {
        this.props.updateUser({
            ...this.state,
            id: this.props.user.id,
        }).then((result) => {alert('Gebruiker bijgewerkt'); history.push('/agenda');})
            .catch((error) => {
                if (error.response.data && error.response.data.errors && error.response.data.errors.password) {
                    return alert('Wachtwoord wijzigen mislukt: huidig wachtwoord onjuist of nieuw wachtwoord voldoet niet aan de eisen. Probeer aub opnieuw');
                }

                alert('Er ging iets mis met het bijwerken van je account. Probeer aub opnieuw');
            });
    }

    render() {
        let trialEndsAt = '';
        let licenseEndsAt = '';

        if (this.props.user.trial_ends_at) {

            let trialEnd = new Date(this.props.user.trial_ends_at.split(' ')[0]);
            trialEndsAt = trialEnd.getDate()+'-'+(trialEnd.getMonth() + 1)+'-'+trialEnd.getFullYear();
        }

        if (this.props.user.license_ends_at) {

            let licenseEnd = new Date(this.props.user.license_ends_at.split(' ')[0]);
            licenseEndsAt = licenseEnd.getDate()+'-'+(licenseEnd.getMonth() + 1)+'-'+licenseEnd.getFullYear();
        }

        return (
            <div styleName="profile-background">
                <div styleName='hamburger-icon' onClick={this.switchMenu}><FontAwesomeIcon styleName='icon' icon={[ 'far', 'bars' ]}/></div>
                <Popup handleClose={this.switchMenu} visible={this.state.showMenu} click={this.switchMenu}>
                    <Menu handleClose={this.switchMenu} open={this.state.showMenu} click={this.switchMenu}/>
                </Popup>
                <div styleName="top-bar">
                    <h1 styleName="title">Profiel</h1>
                </div>
                <div styleName="content">
                    <form styleName="register-form">
                        <p>Voornaam</p>
                        <input styleName="input-box" type="text" 
                            value={this.state.name} onChange={this.handleNameChange}/>

                        <p>Emailadres</p>
                        <input styleName="input-box" type="email" 
                            value={this.state.email} onChange={this.handleEmailChange}/>

                        <p>Huidig wachtwoord</p>
                        <input styleName="input-box" type="password"
                            value={this.state.password_current}  onChange={this.handleCurrentPasswordChange}/>

                        <p>Nieuw wachtwoord</p>
                        <input styleName="input-box" type="password"
                            value={this.state.password}  onChange={this.handleNewPasswordChange}/>

                        <p>Herhaal wachtwoord</p>
                        <input styleName="input-box" type="password"
                            value={this.state.password_confirmation}  onChange={this.handlePasswordConfirmationChange}/>

                        
                    </form>
                    <div styleName="actions">
                        <p onClick={this.updateUser}>Gegevens aanpassen</p>
                    </div>
                </div>

                <div styleName="top-bar">
                    <h1 styleName="title">Licentie</h1>
                </div>

                <div styleName="content license" >
                    {
                        this.props.user.on_trial &&
                        <Fragment>

                            <h6>Op dit moment heb je een proefaccount</h6>
                            <p>Je proefaccount is geldig tot {trialEndsAt}</p>
                            <p>Een jaarlicentie kost momenteel &euro;14,90. Daarmee maak je een jaar lang onbeperkt gebruik van de Plenda Applicatie. Betaal je licentie eenvoudig en snel via iDeal.</p>
                            <div styleName='button' onClick={this.buyLicense}>
                                    Licentie kopen
                            </div>

                        </Fragment>

                    }

                    {
                        this.props.user.has_valid_license && !this.props.user.on_trial &&
                        <Fragment>

                            <h6>Op dit moment heb je een jaarlicentie</h6>
                            <p>Je licentie is geldig tot {licenseEndsAt}</p>
                            <p>Een jaarlicentie kost momenteel &euro; 14,90. Daarmee maak je een jaar lang onbeperkt gebruik van de Plenda Applicatie. Betaal je licentie eenvoudig en snel via iDeal.</p>
                            <div styleName='button' onClick={this.buyLicense}>
                                    Licentie verlengen
                            </div>

                        </Fragment>

                    }

                    {
                        !this.props.user.has_valid_license && !this.props.user.on_trial &&
                        <Fragment>

                            <h6>Proefperiode of licentie verlopen</h6>
                            <p>Helaas, je proefperiode is afgelopen of je licentie is niet meer geldig. Je kunt nu geen gebruik meer maken van de Plenda Applicatie.</p>
                            <p>Een jaarlicentie kost momenteel &euro;14,90. Daarmee maak je een jaar lang onbeperkt gebruik van de Plenda Applicatie. Betaal je licentie eenvoudig en snel via iDeal.</p>
                            <div styleName='button' onClick={this.buyLicense}>
                                    Licentie afsluiten
                            </div>

                        </Fragment>

                    }
                    
                </div>

                <div styleName="top-bar">
                    <h1 styleName="title">Account</h1>
                </div>
                <div styleName="content">
                    
                    <div onClick={this.logout} style={{ textAlign: 'center', cursor: 'pointer' }}>
                        <p style={{fontSize:'12px', margin:'5px'}}>Uitloggen</p>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Profile);